
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import AddEditAdminApp from '../components/AddEditAdminApp';
import appUrl from "../../../../constants/appUrl";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { confirmDialog } from 'primereact/confirmdialog';
import moment from 'moment';
const AdminZAppJourney = () => {

    const [products, setProducts] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [appJourneyList, setAppJourneyList] = useState();
    const [res, setRes] = useState(null)
    const [dialog, setDialog] = useState();



    const GetAppJourney = async () => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/AppJourney/GetAllAppJournies`)
            const data = await response.json();
            setAppJourneyList(data)
        }
        catch (error) {

        }
    }

    const actionTemplate = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-pencil" className="custom-btn-edit" />
                <Button icon="pi pi-trash" className="custom-btn-delete" onClick={() => { confirm(rowData) }} />
            </div>
        );
    }
    const accept = async (rowData) => {
        console.log('rowData', rowData)
        const response = await axios.delete(`${appUrl.baseUrl}api/AppJourney/DeleteAppJourneyByID/${rowData?.appJourneys?.appJourneyID}`)
        setRes(response)
        toast.success("Delete Succesfully")
    }
    const reject = (rowData) => {
        return
    }
    const confirm = (rowData) => {
        confirmDialog({
            header: 'Delete',
            message: 'Are u sure want to delete data',
            accept: () => accept(rowData),
            reject: () => reject(rowData),
            acceptClassName: 'custom-bg',
            rejectClassName: 'custom-white',
        })
    }

    const actionEye = (rowData) => {
        return (
            <div>
                <Button icon="pi pi-eye" className="custom-btn-edit" />
            </div>
        );
    }

   
    const onHide = () => {
        setDialog(false)
    }

    useEffect(() => {
        GetAppJourney()
    }, [res])

    // const onRowExpand = (event) => {
    //     toast.info('Product Expanded: ' + event.data.name);
    // };

    // const onRowCollapse = (event) => {
    //     toast.success('Product Collapsed: ' + event.data.name);
    // };



    const expandAll = () => {
        let _expandedRows = {};

        products.forEach((p) => (_expandedRows[`${p.id}`] = true));

        setExpandedRows(_expandedRows);
    };

    const collapseAll = () => {
        setExpandedRows(null);
    };

    const allowExpansion = (rowData) => {
        return rowData.orders.length > 0;
    };

    const rowExpansionTemplate = (rowData) => {
        return (
            <div className="p-3">
                <DataTable value={rowData.appJourneys}>
                    <Column field="appJourneyID" header="App Journey ID" />
                    <Column field="channelID" header="Channel ID" />
                    <Column field="createdDate" header="Created Date"  body={(rowData) => new Date(rowData.createdDate).toLocaleDateString('en-GB')}/>
                    <Column field="title" header="Title" />
                    <Column header="Attachment" body={actionEye} />
                    <Column header="Action" body={actionTemplate} />
                </DataTable>
            </div>
        );
    };



    return (
        <>
            <Dialog visible={dialog} onHide={onHide}
                header={"New Product"}
                style={{ width: "70vw" }}>
                <AddEditAdminApp />
            </Dialog>
        
        <div className='grid'>
          <div className="md:col-10" ></div>
            <div className="md:col-2" >
                <div >
                    <Button className="p-button custom-bg w100" label="New Prodcut" onClick={() => { setDialog(true) }} />
                </div>
            </div>
            <div className="card">
                <ToastContainer />
                <div className='md:col-12' >
                    <DataTable value={appJourneyList} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                        rowExpansionTemplate={rowExpansionTemplate}
                        dataKey="id" >
                        <Column expander={allowExpansion} style={{ width: '5rem' }} />
                        <Column header="Product ID" field='productID' />
                        <Column header="Product Name" field='productName' />
                        <Column header="Product Channel" field='productChannel' />
                        <Column header="Created Date" field='productCreatedDate' body={(rowData) => new Date(rowData.productCreatedDate).toLocaleDateString('en-GB')} />


                    </DataTable>
                </div>
            </div>
        </div>
        </>
    );
}
export default AdminZAppJourney